// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkflowFinishedPanel_root","message":"WorkflowFinishedPanel_message"};